import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'list': [],
  'filteredList': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

export const priceFactorsGroups = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_PRICE_FACTORS_GROUPS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCH_PRICE_FACTORS_GROUPS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCH_PRICE_FACTORS_GROUPS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    
  })(state, action);
};
